// 404 page
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMainPageTitle } from "../contexts/PageContext";

export default function NotFound() {
  const { t } = useTranslation();
  const { updatePageTitle } = useMainPageTitle();
  
  useEffect(() => {
    updatePageTitle("404", t("pages.404.title"));
  }, [updatePageTitle, t]);

  return (
    <div className="xl:mt-[150px] flex items-center justify-center p-4">
      <div className="text-center space-y-8">
        {/* 404 Animation */}
        <div className="relative">
          <h1 className="text-[150px] md:text-[200px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#E86936] to-[#155660] animate-pulse">
            404
          </h1>
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 transform">
            <div className="w-24 h-24 md:w-32 md:h-32">
              <svg 
                viewBox="0 0 24 24" 
                className="w-full h-full fill-current text-gray-300 animate-bounce"
              >
                <path d="M21.71 11.29l-9-9a.996.996 0 00-1.41 0l-9 9a.996.996 0 000 1.41l9 9c.39.39 1.02.39 1.41 0l9-9a.996.996 0 000-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Message */}
        <div className="space-y-4">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
            {t("pages.404.subtitle")}
          </h2>
          <p className="text-gray-600 max-w-md mx-auto">
            {t("pages.404.description")}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="px-8 py-3 bg-gradient-to-r from-[#E86936] to-[#155660] text-white rounded-full font-medium hover:opacity-90 transition-opacity focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            {t("pages.404.goHome")}
          </Link>
        </div>
      </div>
    </div>
  );
}


